import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(addToListLinkStyles, {
    wrapper: {
        css: css`
            text-align: center;
            margin-top: 0px;
            @media (max-width: 991px) {
                margin-top: 10px !important;
            }
        `,
    },
    link: {
        link: {
            color: COLORS.primary.base,
            typographyProps: {
                size: TYPOGRAPHY.size.smaller,
            },
            css: css`
                &:hover {
                    text-decoration: underline;
                    color: ${COLORS.primary.base};
                }
            `,
        },
    },
});
